import { CustomForm } from '../../../../../models/types/CustomForm';

import { FormColumn } from '../../../../UI/Form/FormColumn/FormColumn';

import { Wrapper } from './keRenewSubscriptionDetails.styles';
import { SubscriptionRenewDetailsCommonForm } from '../../Common/SubscriptionRenewDetailsCommonForm/SubscriptionRenewDetailsCommonForm';
import { ProductType } from '../../../../../models/ProductType';

export const KERenewSubscriptionDetails = ({ disabled }: CustomForm) => (
  <Wrapper>
    <FormColumn>
      <SubscriptionRenewDetailsCommonForm
        disabled={disabled}
        productType={ProductType.KidnapAndExtortion}
      />
    </FormColumn>
  </Wrapper>
);
